import React from "react";
import { Box, useTheme } from "@mui/material";

const Background = ({ children, height = "auto" }) => {
  const colourTheme = useTheme();
  return (
    <Box
      sx={{
        backdropFilter: "blur(1rem)",
        boxShadow: "0 0 1rem rgba(0, 0, 0, 0.2)",
        width: "100%",
        border: `1px solid ${colourTheme.palette.text.primary}`,
        borderRadius: "1rem",
        m: "auto",
        mb: 2.5,
        p: 1.5,
        height: height,
      }}
    >
      {children}
    </Box>
  );
};

export default Background;
